<ng-container *transloco="let t">
  <div class="container"></div>
  <header class="header d-flex align-items-center {{additionalClass}}" [class.landing]="isLanding"
          [class.fixed-top]="!isLanding">
    <div class="container py-0 navigation" [class.container--header]="isLanding">
      <div class="d-flex flex-wrap justify-content-between position-relative" [class.align-items-center]="!isLanding">

        <!--   Logo image - SM screen only-->
        @if (!isLanding) {
          <div class="mobile-logo" (click)="onClickToLogoImage()">
            <div class="d-xxl-none">
              <button class="flat-btn active logo-sm logo-sm--inner">
                <img alt="Tracey logo" src="assets/img/svg/Tracey_like_ikon_full_white_heartless.svg">
              </button>
            </div>
          </div>
        }

        <!--        Logo image - XXL screen only-->
        <app-logo-xxl [isLanding]="isLanding" (logoClick)="onClickToLogoImage()"/>

        <!--        Logged out - menu - XXL screen only-->
        <ul
          class="nav col-12 col-xxl-auto justify-content-start  mb-md-0 d-none d-xxl-flex flex-grow-1 ps-4 align-items-start"
          [class.mt-18]="isLanding" [class.ms-100]="!isLanding">
          <li [class.active]="isRouteActive('EVENT_CALENDAR')"><a (click)="onEventCalendar()">{{
              t(
                'page.header.event.calendar')
            }}</a></li>
          <li [class.active]="isRouteActive('FINISHED')"><a (click)="goToFinished()">{{
              t(
                'page.header.finished.events')
            }}</a></li>
          <li [class.active]="isRouteActive('LIVE_RESULTS')"><a (click)="goToLiveResults()">{{
              t(
                'page.header.live.results')
            }}</a></li>
          @if(environment.isLeagueVisible) {
            <li [class.active]="isRouteActive('SERIES')"><a (click)="goToSeries()">{{
              t(
                'page.header.series')
            }}</a></li>
          }
          <li [class.active]="isRouteActive('USER_PROFILE_VIEW_ROUTE')">
            @if (authenticationService.isAuthenticated()) {
              <a (click)="goToMyTracey()">{{
                  t('app.common.myTracey')
                }}
              </a>
            }
          </li>
        </ul>
        @if (!authenticationService.isAuthenticated()) {
          <ul class="d-none d-xxl-flex align-items-start" [class.mt-18]="isLanding">
            <li>
              <a (click)="goToSignup()" [class.active]="isRouteActive('SIGNUP_ROUTE')"
                 [class.px-3]="currentWindowWidth > 1200">{{ t('app.common.signup') }}</a>
            </li>
          </ul>
        }

        <!-- Logged in part of page header -->
        @if (authenticationService.isAuthenticated()) {
          <div class="d-none d-xxl-flex">
            <ul>
              <li>
                <a (click)="onOrganiserButtonClick()">{{ t('app.common.organizer') }}</a>
              </li>
            </ul>
          </div>
          <div class="d-none d-xxl-flex remove-dropdown-icon dropdown-header" ngbDropdown>
            <div class="circle" id="myNotificationsDropdown" ngbDropdownToggle>
              <i class="bi bi-bell"></i>
              @if (unreadMessages?.length ?? 0 > 0) {
                <div class="unread-msg-circle">
                  {{ unreadMessages?.length }}
                </div>
              }
            </div>
            <div ngbDropdownMenu aria-labelledby="languageDropdown">
              <button ngbDropdownItem (click)="goToMessages(false)">
              <span>
                {{ 'app.common.unread' | transloco }}
              </span>
              </button>
              <button ngbDropdownItem (click)="goToMessages(true)">
              <span>
                {{ 'app.common.read' | transloco }}
              </span>
              </button>
            </div>
          </div>
          <div class="d-none d-xxl-flex remove-dropdown-icon dropdown-header" ngbDropdown>
            <button type="button" class="btn" id="myProfileDropdown" ngbDropdownToggle>
              <div class="profile-box">
                @if (currentUserDetails?.picture) {
                  <img [src]="currentUserDetails!.picture" class="avatar" alt="Avatar"/>
                } @else {
                  <div class="profile-box__initials">
                    <p>
                      {{ currentUserDetails?.firstname?.charAt(0)?.toUpperCase() }}{{
                        currentUserDetails?.lastname?.charAt(
                          0)?.toUpperCase()
                      }}
                    </p>
                  </div>
                }
              </div>
            </button>
            <div ngbDropdownMenu aria-labelledby="myProfileDropdown">
              <p class="fw-semibold px-3 py-3 dropdown-subtitle text-uppercase">{{ t('page.header.profile') }}</p>
              <button ngbDropdownItem (click)="onOpenProfile()">{{ t('page.header.profile.settings') }}</button>
              <button ngbDropdownItem (click)="logout()">{{ t('app.common.logout') }}</button>
            </div>
          </div>
          <div class="d-flex flex-xxl-grow-0 flex-grow-1 justify-content-end ps-2">
            @if (currentWindowWidth < 1400 && !isLanding) {
              <!--   Hamburger menu icon - SM screen only-->
              <ng-template [ngTemplateOutlet]="hamburgerMenu">
              </ng-template>
            }

          </div>
        } @else {
          <!-- Logged out part of page header -->
            <!--  Logo - SM screen only-->
          @if (isLanding) {
            <div class="d-xxl-none">
              <button class="flat-btn active logo-sm">
                <img alt="Tracey logo" src="assets/img/svg/Tracey_like_ikon_full_white_heartless.svg">
              </button>
            </div>
          }

          <div class="d-flex flex-xxl-grow-0 ps-4 ps-xxl-0" [class.flex-grow-1]="isLanding"
               [class.align-items-start]="isLanding"
               [class.mt-20]="isLanding">
            <div class="d-flex flex-column" [class.d-none]="isLanding" [class.d-xxl-flex]="isLanding">
              <div class="d-flex flex-row align-items-center translate-icons">
                @if (authenticationService.isAuthenticated()) {
                  <div class="position-relative me-4">
                    <img class="icon cursor-pointer" src="assets/img/svg/bell.svg" alt="notifications" width="26"
                         height="18">
                    <span class="unread-msg">3</span>
                  </div>
                }
                @if (currentWindowWidth < 1400 && !isLanding) {
                  <ng-container>
                    <!--   Hamburger menu icon - SM screen only-->
                    @if (!isLanding) {
                      <ng-template [ngTemplateOutlet]="hamburgerMenu">
                      </ng-template>
                    }
                  </ng-container>
                } @else {
                  <img class="icon mx-3 me-md-4 cursor-pointer" src="assets/img/svg/person.svg" alt="settings"
                       width="26"
                       height="18" (click)="goToLogin()">
                }
              </div>
            </div>
          </div>
        }
        <!--   Hamburger menu icon - SM screen only-->
        @if (isLanding) {
          <ng-template [ngTemplateOutlet]="hamburgerMenu">
          </ng-template>
        }

      </div>
    </div>
  </header>

  <!--   Mobile menu - SM screen only-->
  <div class="slide-in-element d-xxl-none"
       [@slideInOut]="isMobileMenuVisible ? (isLanding ? 'inLanding' : 'in') : 'out'">
    <ul class="navigation-mobile" [class.landing]="isLanding">
      @if (!isLanding) {
        <li (click)="onClickToLogoImage()">{{ t('page.header.home') }}</li>
      }
      <li (click)="onEventCalendar()" [class.active]="isRouteActive('EVENT_CALENDAR')">{{
          t('page.header.event.calendar')
        }}
      </li>
      <li (click)="goToFinished()" [class.active]="isRouteActive('FINISHED')">{{
          t('page.header.finished.events')
        }}
      </li>
      <li (click)="goToLiveResults()" [class.active]="isRouteActive('LIVE_RESULTS')">{{
          t('page.header.live.results')
        }}
      </li>
      @if(environment.isLeagueVisible) {
      <li [class.active]="isRouteActive('SERIES')" (click)="goToSeries()">{{
          t('page.header.series')
        }}
      </li>
      }
      @if (authenticationService.isAuthenticated()) {
        <li (click)="goToMyTracey()" [class.active]="isRouteActive('USER_PROFILE_VIEW_ROUTE')">{{
            t('app.common.myTracey')
          }}
        </li>
      }
      <!-- @if (authenticationService.isAuthenticated()) {
        <div>
          <li class="toggle-icon px-3" (click)="collapseRaces.toggle()" [attr.aria-expanded]="!isRacesCollapsed">{{
              t('page.header.my.races')
            }}
          </li>
          <div #collapseRaces="ngbCollapse" [(ngbCollapse)]="isRacesCollapsed">
            <ul>
              <li (click)="goToRegistered()" [class.active]="isRouteActive('MY_REGISTERED')">{{
                  t('page.header.registered.races')
                }}
              </li>
              <li (click)="goToMyFinished()" [class.active]="isRouteActive('MY_FINISHED')">{{
                  t('page.header.my.finished.races')
                }}
              </li>
              <li (click)="goToFavorites()">{{ t('page.header.favorites.races') }}
              </li>
            </ul>
          </div>
          <li>{{ t('page.header.notifications') }}</li>
          <li (click)="onOpenProfile()">{{ t('page.header.profile.settings') }}</li>
        </div>
      } -->

      <li (click)="goToContact()" [class.active]="isRouteActive('CONTACT')">{{ t('footer.about.contact') }}</li>
      <li (click)="goToPrivacyPolicy()" [class.active]="isRouteActive('PRIVACY')">{{ t('footer.privacy.policy') }}</li>
      @if (authenticationService.isAuthenticated()) {
        <li (click)="logout()" [class.active]="isRouteActive('SIGN_UP')">{{ t('app.common.logout') }}</li>
      } @else {
        <li (click)="goToSignup()" [class.active]="isRouteActive('SIGN_UP')">{{ t('app.common.signup') }}</li>
        <li (click)="goToLogin()" [class.active]="isRouteActive('LOGIN')">{{ t('app.common.login') }}</li>
      }
    </ul>
  </div>
  <ng-template #hamburgerMenu>
    <div class="hamburger-button d-xxl-none" (click)="toggleMobileMenuVisibility()"
         [class.hamburger-button--landing]="isLanding">
      @if (isMobileMenuVisible && isLanding) {
        <img src="assets/img/svg/mobile-menu.svg" alt="Menu">
      } @else {
        <img src="assets/img/svg/mobile-menu-inner.svg" alt="Menu"/>
      }
    </div>
  </ng-template>
</ng-container>
